import * as React from 'react'
import Async, { AsyncProps as ReactAsyncSelectProps } from 'react-select/async'
import { Input } from '../input/input'
import { useSelectStyles } from './useSelectStyles'
import { OptionTypeBase } from '../../interface/optionTypeBase'
import { GroupBase } from 'react-select'

export interface AsyncSelectProps<OptionType extends OptionTypeBase>
  extends ReactAsyncSelectProps<OptionType, boolean, GroupBase<OptionType>> {
  invalid?: boolean
  readOnly?: boolean
}

function AsyncSelectWithRef<
  OptionType extends OptionTypeBase = { label: string; value: string }
>(
  {
    invalid,
    readOnly,
    styles,
    getOptionLabel = (option: OptionType): string => option.label,
    ...props
  }: AsyncSelectProps<OptionType>,
  ref: React.RefObject<any>
) {
  if (readOnly) {
    const displayValue = props.value
      ? getOptionLabel(props.value as OptionType)
      : ''

    return (
      <Input id={props.inputId} type="text" readOnly value={displayValue} />
    )
  } else {
    const selectStyles = useSelectStyles(invalid, styles)
    return (
      <Async<OptionType, boolean> {...props} styles={selectStyles} ref={ref} />
    )
  }
}

export const AsyncSelect = React.forwardRef(AsyncSelectWithRef) as <
  OptionType extends OptionTypeBase = { label: string; value: string }
>(
  props: AsyncSelectProps<OptionType> & { ref?: React.RefObject<any> }
) => ReturnType<typeof AsyncSelectWithRef>
